import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ToastService } from '../../shared/services/toast.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {

  const toastService = inject(ToastService);

  return next(req).pipe(
    tap({
      error: (error) => {

        console.error('Http Error', error);

        if (req.headers.has('skipErrorHandler')) {
          return;
        }

        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 0:
              toastService.showError('No se pudo conectar al servidor.');
              break;
            case 400:
              toastService.showError('Solicitud incorrecta. Revisa los datos enviados.');
              break;
            case 401:
              toastService.showError('No estás autorizado. Inicia sesión.');
              break;
            case 403:
              toastService.showError('No tienes permisos para realizar esta acción.');
              break;
            case 404:
              toastService.showError('El recurso solicitado no fue encontrado.');
              break;
            case 500:
              toastService.showError('Error interno del servidor. Intenta más tarde.');
              break;
            default:
              toastService.showError('Ocurrió un error inesperado.');
              break;
          }
        }
      }
    })
  );


};
